

export const hexToRGB=(hex:string):[r:number,g:number,b:number]=>{
    // Remove the hash symbol if present


    
    hex = hex.replace('#', '');
    
   
    // Parse red, green, and blue components
    const r = parseInt(hex.substring(0, 2), 16) / 255;
    const g = parseInt(hex.substring(2, 4), 16) / 255;
    const b = parseInt(hex.substring(4, 6), 16) / 255;

    return [r, g, b ];
}
